//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "LegacyPressePost",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
